import React, { useEffect, useState } from "react";
import {
    Card,
    Form,
    InputGroup,
    Button
} from "react-bootstrap";
import {
    DataGrid,
    Column,
    Pager,
    Paging,
    Summary,
    TotalItem,
    Selection,
    Scrolling
} from "devextreme-react/data-grid";
import { getRepairProductBySearch } from "../services";
import notistack from "modules/core/notistack";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";
import { BiSolidRightArrowAlt } from "react-icons/bi";
import { encryptItem } from "helpers/secureNavigate";
import { HasPermission } from "Layout/Permissions/permissionsCache";

const RepairWorkSearch = () => {
    const [data, setData] = useState<any[]>([]);
    const [searchText, setSearchText] = useState("");
    const [selectedKeys, setSelectedKeys] = useState<number[]>([]);
    const [selectedRow, setSelectedRow] = useState<any | null>(null);
    const navigate = useNavigate();
    const [searchData, setSearchData] = useState<any>()
    // /repair-products-details/:id/:customerId/:search

    const handleSearch = async () => {
        // if (!searchText.trim()) return;
        if (searchText.trim() === "") {
            notistack.warning("Enter Invoice No to Search");
            return;
        }
        try {
            setSearchData(searchText.trim())
            const response = await getRepairProductBySearch(searchText);
            setData(response || []);
        } catch (error) {
            console.error("Search failed:", error);
            setData([]);
        }
    };

    const handleSelectionChange = (e: any) => {
        const grid = e.component;
        if (e.selectedRowKeys.length > 1) {
            const latestKey = e.currentSelectedRowKeys[0];
            grid.selectRows([latestKey], false);
            setSelectedKeys([latestKey]);
            setSelectedRow(e.selectedRowsData[0]);
        } else {
            setSelectedKeys(e.selectedRowKeys);
            setSelectedRow(e.selectedRowsData[0] || null);
        }
    };


    const passToRepairProductDetails = () => {
        if (selectedRow) {
            const id = encryptItem(selectedRow.id)
            const customerId = encryptItem(selectedRow.customerId)
            if (id && customerId) {
                navigate(`/repair-products-details/${id}/${customerId}`);
            }
        } else {
            notistack.warning("Please select a product details.");
        }
    };

    return (
        <div className="page-content">
            <div className="container-fluid">
                <Card>
                    <Card.Header className="d-flex justify-content-between align-items-center">
                        <h5 className="m-0">Repair Product Search</h5>
                        {HasPermission("RepairWork.Write") &&
                            <div className="d-flex align-items-center gap-2">
                                <input
                                    type="text"
                                    placeholder="Enter Invoice No"
                                    value={searchText}
                                    style={{ width: "200px" }}
                                    className="form-control"
                                    onChange={(e) => setSearchText(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === "Tab") {
                                            e.preventDefault();
                                            handleSearch();
                                        }
                                    }}
                                />
                                <button onClick={handleSearch} className="submit-btn">
                                    Search
                                </button>
                                <Button className="submit-btn " onClick={passToRepairProductDetails}>
                                    <BiSolidRightArrowAlt size={15} />
                                </Button>
                            </div>
                        }
                    </Card.Header>

                    {HasPermission("RepairWork.Read") &&
                        <Card.Body>
                            <DataGrid
                                dataSource={data}
                                keyExpr="id"
                                showRowLines
                                showBorders
                                remoteOperations={false}
                                allowColumnResizing
                                columnAutoWidth
                                wordWrapEnabled
                                onSelectionChanged={handleSelectionChange}
                                onContentReady={(e) => {
                                    const hasData = e.component.totalCount() > 0;
                                    e.component.option("pager.visible", hasData);
                                    e.component.option("paging.visible", hasData);
                                }}
                            >
                                <Scrolling
                                    mode='standard'
                                    useNative={true}
                                    scrollByContent={true}
                                    scrollByThumb={true}
                                />
                                <Paging defaultPageSize={10} />
                                <Selection mode="multiple" showCheckBoxesMode="always" />
                                <Pager
                                    allowedPageSizes={[10, 25, 50, 100]}
                                    showPageSizeSelector
                                    showNavigationButtons
                                    displayMode="full"
                                    showInfo
                                />
                                <Summary>
                                    <TotalItem />
                                </Summary>

                                <Column dataField="id" dataType="number" visible={false} />
                                <Column dataField="styleNo" caption="Style No" />
                                <Column dataField="category" caption="Category" />
                                <Column dataField="diaWt" caption="Dia Wt" dataType="number" format="#,##0.000" />
                                <Column dataField="diaQty" caption="Dia Qty" dataType="number" />
                                <Column dataField="netWt" caption="Net Wt" dataType="number" format="#,##0.000" />
                                <Column dataField="grossWt" caption="Gross Wt" dataType="number" format="#,##0.000" />
                                <Column dataField="kt" caption="Metal KT" />
                                <Column dataField="pcs" caption="Quantity" dataType="number" />
                                <Column dataField="igiNo" caption="IGI No" />
                                <Column dataField="huid" caption="HUID" />
                                <Column
                                    dataField="sellingPrice"
                                    caption="Selling Price"
                                    dataType="number"
                                    format="#,##0.00"
                                    cellRender={({ data }) => data.sellingPrice?.toFixed(2)}
                                />
                                {/* <Column dataField="customerId" caption="Customer ID" dataType="number" /> */}
                            </DataGrid>
                        </Card.Body>
                    }
                </Card>
            </div>
        </div>
    );
};

export default RepairWorkSearch;
